export * as FontSizes from './FontSizes';
export * as FontWeights from './FontWeights';
export * as IconFontSizes from './IconFontSizes';

export const DEFAULT_FONT_FAMILY = 'Gellix';
// Fallback fonts, if specified system or web fonts are unavailable.
export const FONT_FAMILY_FALLBACKS = `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`;
